module.exports = __webpack_public_path__ + "img/alex3.3fc621b2.png";